import { useState, useEffect, useRef } from "react";
import { getLightColour } from "../Components/Util";

export default function IconCell2(props) {
  const [size, setSize] = useState({
    width: 1,
    height: 1,
  });
  const [hover, setHover] = useState(false);
  const myDiv = useRef();
  const myCanvas = useRef();

  useEffect(
    () => {
      Draw(myCanvas.current.getContext("2d"));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [size, props, hover]
  );

  new ResizeObserver((div) => {
    if (myDiv) {
      if (myDiv.current) {
        if (myDiv.current.clientHeight) {
          let newHeight = myDiv.current.clientHeight;
          let newWidth = myDiv.current.clientWidth;
          if (newWidth !== size.width || newHeight !== size.height) {
            setSize({ width: newWidth, height: newHeight });
          }
        }
      }
    }
  }).observe(document.querySelector("div"));

  function Draw(ctx) {
    let width = (200 * size.width) / size.height;
    let height = 200;
    let image = new Image();
    image.src = `${process.env.PUBLIC_URL}/icons/${props.imageName}`;
    image.onload = function () {
      ctx.clearRect(0, 0, width, height);
      ctx.globalAlpha = 1.0;
      const gradient = ctx.createLinearGradient(0, 0, 0, height);
      gradient.addColorStop(0.0, hover ? getLightColour() : "whitesmoke");
      gradient.addColorStop(1.0, "white");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
      ctx.globalAlpha = 0.1;
      ctx.drawImage(image, width * 0.85 - 80, (height - 150) * 0.5, 150, 150);
      ctx.globalAlpha = 1.0;
      if (props.text1) {
        ctx.font = "normal 30px Roboto";
        ctx.fillStyle = "black";
        ctx.textAlign = "left";
        ctx.fillText(props.text1, width * 0.01, height * 0.3);
      }
      if (props.text2) {
        ctx.font = "normal 30px Roboto";
        ctx.fillStyle = "black";
        ctx.textAlign = "left";
        ctx.fillText(props.text2, width * 0.01, height * 0.5);
      }
      if (props.text3) {
        ctx.font = "normal 30px Roboto";
        ctx.fillStyle = "black";
        ctx.textAlign = "left";
        ctx.fillText(props.text3, width * 0.01, height * 0.7);
      }
      if (props.subtitle1) {
        ctx.font = "normal 30px Roboto";
        ctx.fillStyle = "black";
        ctx.textAlign = "center";
        ctx.fillText(props.subtitle1, width * 0.85, height * 0.5 + 40);
      }
      if (props.subtitle2) {
        ctx.font = "normal 30px Roboto";
        ctx.fillStyle = "black";
        ctx.textAlign = "center";
        ctx.fillText(props.subtitle2, width * 0.85, height * 0.5 + 80);
      }
    };
  }

  return (
    <div
      className={"cell"}
      ref={myDiv}
      onClick={props.onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <canvas
        ref={myCanvas}
        width={(200 * size.width) / size.height}
        height={200}
        style={{ width: size.width, height: size.height }}
      />
    </div>
  );
}
